import React, { useRef } from 'react';
import cx from 'classnames';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Section from 'components/common/Section';
import Reinsurance, { NewReinsurance } from 'templates/Pathologies/common/Reinsurance';
import Cta from 'components/common/Cta';
import VideoSection from 'templates/Pathologies/common/VideoSection';
import { AirtableImages } from 'components/common/utils/AirtableImage';
import { useAnchorEffect, scrollToAnchor } from "components/common/CharlesLayout/useAnchorEffect";
import { Charles, Standard } from 'types/index';
import AnchorMenu from 'templates/Pathologies/common/AnchorMenu';
import MeetBooked from 'images/new-images/calendar.svg';

import './styles.sass'

type Anchor = {
  id: string,
  label: string,
}

type Props = {
  h1: Standard.Markdown
  subtitle: Standard.Markdown
  cta_label: string
  start_slug: string
  border_icon: Charles.ImageRecord[]
  main_video: Charles.YoutubeVideoRecord[]
  reinsurance_items: Charles.ItemRecord[]
  cta: React.ReactNode
  anchors: Anchor[]
  nextMeetDate: string | null
}

const TopSection = (props: Props) => {
  const anchorLinksContainerRef: any = useRef();
  const anchorLinksRefs: any = useRef({});

  const [scrollStatus, setScrollStatus]: any[] = useAnchorEffect(anchorLinksContainerRef, anchorLinksRefs, 'pathology-anchor', 200)

  return (
    <>
      <Section id="pathology-head" className="pathology-heading-section">
        <div className="pathology-top-section-background-wrapper" style={{ display: 'grid' }}>
          <div
            className="background-image-part-pathology-top-section"
            style={{
              gridArea: '1/1',
            }}
          >
            <Container>
              <Row className="justify-content-end">
                <Col md={9} xl={5}>
                  <AirtableImages
                    images={props.border_icon}
                    className="background-image-pathology-top-section"
                  />
                </Col>
              </Row>
            </Container>
          </div>
          <div
            className="content-part-pathology-testimony"
            style={{
              // By using the same grid area for both, they are stacked on top of each other
              gridArea: '1/1',
              position: 'relative',
            }}
          >
            <Container className="pathology-top-container">
              <Row className="justify-content-md-center">
                <Col xs={12} xl={7}>
                  <h1 className="h1 pathology-h1">{props.h1.childMarkdownRemark.rawMarkdownBody}</h1>
                  <div className="pathology-subtitle" dangerouslySetInnerHTML={{ __html: props.subtitle.childMarkdownRemark.html }} />
                  <div className="pathology-cta-content">
                    {props.cta || <Cta text="Consultez un spécialiste" className="new-primary-cta pathology-cta" path={props.start_slug} />}
                    { props.nextMeetDate && 
                      <div className="pathology-next-meet-date">
                        <MeetBooked width={32} /><span>{props.nextMeetDate}</span>
                      </div>}
                  </div>
                  <Reinsurance className="reinsurance-wrapper-pathology" reinsurance_items={props.reinsurance_items} />
                </Col>
                <Col xs={12} md={9} xl={5} className="pathology-heading-video-col">
                  <VideoSection videos={props.main_video} />
                </Col>
              </Row>
            </Container>
            <NewReinsurance reinsurance_items={props.reinsurance_items} />
          </div>
        </div>
      </Section>
      <AnchorMenu
        anchors={props.anchors}
        scrollingUp={scrollStatus.scrollingUp}
        hoveredAnchorId={scrollStatus.hoveredAnchorId}
        anchorLinksRefs={anchorLinksRefs}
        anchorLinksContainerRef={anchorLinksContainerRef}
        scrollOffset={20}
      />
    </>
  );
};

export default TopSection;
